import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import ArrowLeftIcon from '@material-ui/icons/ArrowLeft';
import ArrowRightIcon from '@material-ui/icons/ArrowRight';
import AssignmentTurnedInIcon from '@material-ui/icons/AssignmentTurnedIn';
import TestABC from './TestABC';
import TestTransform from './TestTransform';
import TestIsCorrect from './TestIsCorrect';
import TestInsert from './TestInsert';

const useStyles = makeStyles(theme => ({
  wrap: {
    width: 600,
    maxWidth: '100%',
    textAlign: 'center',
    margin: '0 auto',
    userSelect: 'none',
  },
  test: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    width: '100%',
  },
  answers: {
    width: 300,
    '& svg': {
      color: 'green',
    },
  },
  no: {
    width: 60,
    height: 60,
    borderRadius: '50%',
    background: theme.palette.secondary.main,
    fontSize: '1.25em',
    color: '#fff',
    fontWeight: 600,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    lineHeight: 1,
    userSelect: 'none',
    marginTop: 10,
    marginBottom: 15,
  },
  buttons: {
    '& button': {
      margin: theme.spacing(1),
    },
  }
}));

const instructions = {
  abc: 'Spośród podanych niżej możliwości wybierz jedyne poprawne uzupełnienie zdania hasłowego: a, b lub c.',
  transform: 'Przekształć podane słowa tak, aby poniższe zdania były logiczne i poprawne gramatycznie.',
  isCorrect: 'Wśród poniższych zdań wskaż te, które są poprawne gramatycznie. W niepoprawnych wpisz brakujące lub zbędne słowo.',
  insert: 'Wstaw brakujące przyimki.',
}

export default function Test(props) {
  const classes = useStyles();
  const { data } = props;
  const [no, setNo] = useState(0);
  const [answers, setAnswers] = useState([]);
  const [lastNo, setLastNo] = useState(0);
  const q = data[no];

  const next = () => {
    no < data.length - 1 && setNo(no + 1);
    no > lastNo && setLastNo(no);
  }

  const prev = () => {
    no > 0 && setNo(no - 1);
  }

  const intro = <p>{instructions[q.type]}</p>;

  const setAnswer = ans => {
    const newAnswers = [...answers];
    newAnswers[no] = ans.trim().toLowerCase();
    setAnswers(newAnswers);
  }

  const finish = () => {
    const points = data.reduce((points, obj, idx) => {
      const ans = answers[idx];
      if (Array.isArray(obj.correct)) {
        let result = false;
        obj.correct.forEach(res => {
          if (res.toLowerCase() === ans) result = true;
        });
        return result ? ++points : points;
      } else {
        console.log(obj.correct, ans, typeof ans);
        return (obj.correct === ans) ? ++points : points;
      }
    }, 0);
    props.finish(points);
  }

  const testProps = { q, a: answers[no], setAnswer };

  return (
    <>
      <div className={classes.wrap}>
        <div className={classes.test}>
          <div className={classes.no}>
            <span>{no + 1}/{data.length}</span>
          </div>
          {intro}
          {q.type === 'abc'       && <TestABC       {...testProps} />}
          {q.type === 'transform' && <TestTransform {...testProps} />}
          {q.type === 'isCorrect' && <TestIsCorrect {...testProps} />}
          {q.type === 'insert'    && <TestInsert    {...testProps} />}
        </div>
        <div className={classes.buttons}>
          <Button color="secondary" variant="outlined" disabled={no === 0} onClick={prev}>
            <ArrowLeftIcon /> Poprzednie
          </Button>
          <Button color="secondary" variant="outlined" disabled={no === data.length - 1} onClick={next}>
            Następne <ArrowRightIcon />
          </Button>
        </div>
        <div className={classes.buttons}>
          <Button color="secondary" variant="outlined" disabled={lastNo < data.length - 2} onClick={finish} style={{width: 300}}>
            <AssignmentTurnedInIcon /> &nbsp; Zakończ
          </Button>
        </div>
      </div>
    </>
  );

}